export function getManageCustomFiltersUrl(
	projectKey: string,
	boardId: string,
	isCompanyManaged: boolean,
	isUserBoard: boolean,
	isJSMBoard?: boolean,
	// For testing purposes

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	pathname = window.location.pathname,
): string {
	const NEW_SETTINGS_PATH = '/settings/quickFilters';

	if (isJSMBoard) {
		// JSM Boards use their usual URL all the time.
		return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
	}

	if (isCompanyManaged) {
		if (isUserBoard) {
			return pathname.endsWith('/backlog')
				? `${pathname.replace('/backlog', '')}${NEW_SETTINGS_PATH}?from-backlog=1`
				: `${pathname}${NEW_SETTINGS_PATH}`;
		}

		return `/jira/software/c/projects/${projectKey}/boards/${boardId}${NEW_SETTINGS_PATH}${pathname.endsWith('backlog') ? '?from-backlog=1' : ''}`;
	}

	return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
}
